<template>
    <v-list-tile
            avatar
            @click=""
    >
        <v-list-tile-content>
            <v-list-tile-title v-text="client.title"></v-list-tile-title>
            <iframe height="0" width="0" frameborder="0" :src="client.logoutUrl"
                    @load="loadedHandler" @error="errorHandler"></iframe>
        </v-list-tile-content>

        <v-list-tile-avatar>
            <v-progress-circular
                    v-if="loading"
                    indeterminate
                    color="amber"
            ></v-progress-circular>
            <v-icon v-else-if="success" color="success">done</v-icon>
            <v-icon v-else color="error">highlight_off</v-icon>
        </v-list-tile-avatar>
    </v-list-tile>
</template>

<script>
  export default {
    name: 'LogoutClient',
    props: {
      client_id: {
        type: String,
        required: true
      },
      client: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        loading: true,
        success: false,
        error: false,
        timeout: null
      }
    },
    methods: {
      loadedHandler () {
        this.success = true
        this.error = false
        this.loading = false
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.$emit('clientLogoutComplete', this.client_id)
      },
      errorHandler () {
        this.error = true
        this.success = false
        this.loading = false
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.$emit('clientLogoutError', this.client_id)
      },
    }
  }
</script>

<style scoped>

</style>
